import { Select } from "antd";
import { RadioGroup, Button, Tooltip } from 'components';
import { ReactComponent as Info } from 'assets/icons/info-icon.svg';
const { Option } = Select;

export const formFields = [
    {
      label: 'Υπάρχει Μέλος ΑΜΕΑ στην Οικογένεια;',
      id: 'ameaMember',
      type: 'radio',
      className: 'like-text',
      name: 'ameaMember',
      size: 'small',
      span: 16,
      options:[
        { label: 'Ναι', id:'ownerStatusYes',value: true },
        { label: 'Όχι', id:'ownerStatusNo', value: false }
      ],
      rules: [
        { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      ],
      // asterisk: true,
      defaultValue: false,
    },
    {
      label:'Επαληθεύεται;',
      id: 'ameaMemberAud',
      type: 'switch',
      name: 'ameaMemberAud',
      span: 8,
      checkedChildren: 'Ναι',
      unCheckedChildren: 'Όχι',
      rules: [
        { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      ],
      asterisk: false,
      // defaultValue: false,
    },
    {
        label: <>Είναι ενεργή η παροχή ρεύματος;</>,
        id: 'powerSupply',
        type: 'radio',
        className: 'like-text',
        name: 'powerSupply',
        size: 'small',
        span: 16,
        // bold: true,
        options:[
          { label: 'Ναι', id:'powerOn',value: true },
          { label: 'Όχι', id:'powerOff', value: false }
        ],
        defaultValue: true,
        // asterisk: true,
      },
      {
        label:'Επαληθεύεται;',
        id: 'powerSupplyAud',
        type: 'switch',
        name: 'powerSupplyAud',
        span: 8,
        rules: [
          { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        ],
        checkedChildren: 'Ναι',
        unCheckedChildren: 'Όχι',
        // asterisk: true,
        defaultValue: false,
      },
      {
        label:<>Είναι Οικιακή η παροχή ρεύματος;</>,
        id: 'powerSupplyPrivate',
        type: 'radio',
        className: 'like-text',
        name: 'powerSupplyPrivate',
        size: 'small',
        // bold: true,
        options:[
          { label: 'Ναι', id:'powerSupplyPrivateYes',value: true },
          { label: 'Όχι', id:'powerSupplyPrivateNo', value: false }
        ],
        defaultValue: true,
        // asterisk: true,
        span: 16,
      },
      {
        label:'Επαληθεύεται;',
        id: 'powerSupplyPrivateAud',
        type: 'switch',
        name: 'powerSupplyPrivateAud',
        span: 8,
        rules: [
          { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        ],
        checkedChildren: 'Ναι',
        unCheckedChildren: 'Όχι',
        // asterisk: true,
        defaultValue: false,
      },
      {
        label:<>Είναι η Παροχή Ρεύματος Κοινόχρηστη;
          
        </>,
        id: 'powerSupplyPublic',
        type: 'radio',
        className: 'like-text',
        name: 'powerSupplyPublic',
        size: 'small',
        span: 16,
        // bold: true,
        options:[
          { label: 'Ναι', id:'powerSupplyPublicYes',value: true },
          { label: 'Όχι', id:'powerSupplyPublicNo', value: false }
        ],
        defaultValue: true,
        // asterisk: true,
      },
      {
        label:'Επαληθεύεται;',
        id: 'powerSupplyPublicAud',
        type: 'switch',
        name: 'powerSupplyPublicAud',
        span: 8,
        rules: [
          { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        ],
        checkedChildren: 'Ναι',
        unCheckedChildren: 'Όχι',
        // asterisk: true,
        defaultValue: false,
      },
      {
        label: 'Αρ. Εξαρτώμενων Τέκνων',
        id: 'legalChildren',
        type: 'text',
        name: 'legalChildren',
        size: 'large',
        placeholder: 'Εισάγετε Αριθμό Τέκνων',
        simple: true,
        span: 12,
        maxLength: 2,
        rules: [
          { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
          { max: 2 , message: 'Το πεδίο μπορεί να έχει το πολύ 2 χαρακτήρες' },
        ],
        // asterisk: true,
      },
      {
        type: 'empty',
        span: 4, // Adds space without breaking alignment
      },
      {
        label:'Επαληθεύεται;',
        id: 'legalChildrenAud',
        type: 'switch',
        name: 'legalChildrenAud',
        span: 8,
        rules: [
          { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        ],
        checkedChildren: 'Ναι',
        unCheckedChildren: 'Όχι',
        // asterisk: true,
        // defaultValue: false,
      },
      {
        label: 'Ευάλωτo Νοικοκυριό',
        id: 'vulnerableHousehold',
        type: 'text',
        name: 'vulnerableHousehold',
        size: 'large',
        placeholder: '',
        simple: true,
        span: 12,
        rules: [
          { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        ],
      },
      {
        type: 'empty',
        span: 4, // Adds space without breaking alignment
      },
      {
        label:'Επαληθεύεται;',
        id: 'vulnerableHouseholdAud',
        type: 'switch',
        name: 'vulnerableHouseholdAud',
        span: 8,
        rules: [
          { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        ],
        checkedChildren: 'Ναι',
        unCheckedChildren: 'Όχι',
        // This switch is automatically determined by income validation - always disabled
        disabled: true,
      },
      {
        label:'Άλλος Λόγος Απόρριψης',
        id: 'otherReasonAud',
        type: 'radio',
        className: 'like-text',
        name: 'otherReasonAud',
        size: 'small',
        span: 12,
        options:[
          { label: 'Ναι', id:'otherReasonAudYes',value: true },
          { label: 'Όχι', id:'otherReasonAudNo', value: false }
        ],
        rules: [
          { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        ],
        // asterisk: true,
        defaultValue: false,
      },
    ].filter(item => !item?.hidden); 

export const formFields2 = [
      {
        label:'Προς Έγκριση',
        id: 'preApprovalAud',
        type: 'switch',
        name: 'preApprovalAud',
        span: 8,
        rules: [
          { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        ],
        checkedChildren: 'Ναι',
        unCheckedChildren: 'Όχι',
      },
      {
        label:'Προς Απόρριψη',
        id: 'preRejectAud',
        type: 'switch',
        name: 'preRejectAud',
        span: 8,
        rules: [
          { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        ],
        checkedChildren: 'Ναι',
        unCheckedChildren: 'Όχι',
      },
      {
        label:'Προς Επιστροφή',
        id: 'preReturnAud',
        type: 'switch',
        name: 'preReturnAud',
        span: 8,
        rules: [
          { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        ],
        checkedChildren: 'Ναι',
        unCheckedChildren: 'Όχι',
      },
      {
        label: 'Αιτιολόγηση',
        id: 'commentAud',
        type: 'textarea',
        name: 'commentAud',
        size: 'large',
        placeholder: 'Εισάγετε Αιτιολόγηση',
        rows: 16,
        simple: true,
        span: 22,
        maxLength: 1000,
        rules: [
          { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
          // { max: 100 , message: 'Το πεδίο μπορεί να έχει το πολύ 100 χαρακτήρες' },
        ],
        asterisk: true,
      }, 
]

export const formFields3 = [
    {
        label: 'Έντυπα Αξιολόγησης',
        fileCode: 'audDocs',
        id: 'audDocs',
        multiple: true,
        fileLimit: 10
      },
]